var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.375 5.75C6.375 5.05964 6.93464 4.5 7.625 4.5H18.3047C18.995 4.5 19.5547 5.05964 19.5547 5.75V16.4328C19.5547 17.1232 18.995 17.6828 18.3047 17.6828H12.9648C12.6197 17.6828 12.3398 17.403 12.3398 17.0578C12.3398 16.7126 12.6197 16.4328 12.9648 16.4328H18.3047V5.75H7.625V11.0914C7.625 11.4366 7.34518 11.7164 7 11.7164C6.65482 11.7164 6.375 11.4366 6.375 11.0914V5.75Z",
    fill: "#1A181E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1875 11.375C7.28902 11.375 5.75 12.914 5.75 14.8125C5.75 16.711 7.28902 18.25 9.1875 18.25C11.086 18.25 12.625 16.711 12.625 14.8125C12.625 12.914 11.086 11.375 9.1875 11.375ZM4.5 14.8125C4.5 12.2237 6.59867 10.125 9.1875 10.125C11.7763 10.125 13.875 12.2237 13.875 14.8125C13.875 17.4013 11.7763 19.5 9.1875 19.5C6.59867 19.5 4.5 17.4013 4.5 14.8125Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddShape);
export default __webpack_public_path__ + "static/media/add-shape.c76c53ec654f3b5f60df29979142d861.svg";
export { ForwardRef as ReactComponent };